(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('entityDataPopulatorLogic', function () {
        return function ($scope, logic) {
            var watchEntityData = _.noop;
            var entityDataMasterIndex = _($scope.model.widgets).findIndex(function (widget) {
                return widget.logic.entityDataMaster;
            });
            if (entityDataMasterIndex !== -1) {
                watchEntityData = $scope.$watch('model.widgets[' + entityDataMasterIndex + '].entityData', function (info) {
                    _($scope.model.widgets).each(function (widget) {
                        if (widget.logic.entityDataSlave) {
                            widget.entityData = $scope.model.widgets[entityDataMasterIndex].entityData;
                        }
                    });
                });
            }
            return function () {
                watchEntityData();
            };
        };
    });
}());